enum InputValidations {
  VALID = 'valid',
  INVALID = 'invalid',
  DEFAULT = 'default',
}
enum InputTypes {
  TEXT = 'text',
  NUMBER = 'number',
  EMAIL = 'email',
}
enum InputAutoComplete {
  ON = 'on',
  OFF = 'off',
}

enum InputModes {
  TEXT = 'text',
  NUMERIC = 'numeric',
}

export { InputValidations, InputTypes, InputAutoComplete, InputModes };
